import {
  AlfrescoApiService,
  AuthenticationService,
  TranslationService,
} from '@alfresco/adf-core';
import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { Subject } from 'rxjs';

import { EventEmitterService } from './service/event-emitter-service';
import { SolicitacaoService } from './service/solicitacao/solicitacao.service';
import { AuthSsoService } from './sso/auth-sso.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  $isLoggedIn = false; //
  $userAdminState = false;
  $isDrawerOpen = true; //
  $isPrintPage = false;

  $adm = true;
  $acervo = false;
  $solicitacao = false;

  authorityList: Array<string>;

  mostrarMenu = false;
  userActivity;
  userInactive: Subject<any> = new Subject();

  currentTime = new Date();
  year = this.currentTime.getFullYear();

  constructor(
    translationService: TranslationService,
    private authService: AuthenticationService,
    private alfrescoApiService: AlfrescoApiService,
    private solicitacaoService: SolicitacaoService,
    private router: Router,
    private dialogRef: MatDialog,
    private authSso: AuthSsoService,
  ) {
    translationService.use('en');
    // Os APP_INITIALIZERs ja rodaram: o SSO pode entregar o ticket ao ADF e ouvir os 401 do Alfresco.
    this.authSso.onAppReady();
    //this.solicitacaoService.handleError();
    this.setTimeout();
    this.userInactive.subscribe(() => {
      // 58 min parado: apaga a sessao desta aba e refaz a entrada pelo SSO, que volta sem senha se a sessao dele vale.
      this.authSso.clearLocalSession();
      sessionStorage.setItem('routerpast', router.url);
      EventEmitterService.get('isLoggedIn').emit(false);
      this.router.navigate(['sso-login']);
    });
    EventEmitterService.get('isLoggedIn').subscribe(
      (d: boolean) => {
        this.$isLoggedIn = d;
        if (this.$isLoggedIn) {
          this.getAuthority();
        }
      }
    );

    EventEmitterService.get('isPrintPage').subscribe((data => {
      this.$isPrintPage = data;
    }))
  }

  onClickAdm() {
    this.$adm = true;
    this.$acervo = false;
    this.$solicitacao = false;
  }
  onClickAcervo() {
    this.$adm = false;
    this.$acervo = true;
    this.$solicitacao = false;
  }
  onClickSolicitacao() {
    this.$adm = false;
    this.$acervo = false;
    this.$solicitacao = true;
  }

  ngOnInit() {
  }

  onChangeDrawerState() {
    this.$isDrawerOpen = !this.$isDrawerOpen;
  }

  getItemAuthority(key: string) {
    const storedData = sessionStorage.getItem(key);

    if (storedData) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          storedData,
          sessionStorage.getItem('ticket-ECM')
        );
        this.authorityList = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.authorityList;
      } catch (e) {
        sessionStorage.clear();
      }
    }else {
      return this.authorityList = null;
    }
  }

  getAuthority() {
    this.getItemAuthority('authority');
    // Sem as authorities (falha ao carrega-las no login) o menu de admin so fica escondido.
    if (!this.authorityList) {
      return;
    }

    if (
      this.authorityList.includes('LIST_GRUPO_PERMISSION') ||
      this.authorityList.includes('SUPER_USER')
    ) {
      this.$userAdminState = true;
    }
  }

  setTimeout() {
    // 3480000 = 58min
    this.userActivity = setTimeout(
      () => this.userInactive.next(undefined),
      3480000
    );
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  // "Sair" e logout global pelo SSO: o logout do ADF apagaria no Alfresco o ticket que os outros apps tambem usam.
  logout() {
    this.authSso.logout();
  }

  loginRoute() {
    this.router.navigate(['/sso-login']);
  }
}



// WEBPACK FOOTER //
// /app/src/app/app.component.ts